(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mobile-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function(){
  var wrapper = document.querySelector('[data-mobile-menu-wrapper]');
  var toggle  = document.getElementById('mobile-menu-toggle');
  var drawer  = document.getElementById('mobile-menu-drawer');
  if(!toggle || !drawer) return;

  function lockBody(lock){
    document.documentElement.style.overflow = lock ? 'hidden' : '';
    document.body.style.overflow = lock ? 'hidden' : '';
  }

  // Toggle open/close
  toggle.addEventListener('click', function(){
    var open = drawer.classList.toggle('open');
    drawer.hidden = !open;
    toggle.setAttribute('aria-expanded', open);
    lockBody(open);
  });

  // Si el usuario redimensiona a escritorio, cerramos el drawer y liberamos el body
  var mq = window.matchMedia('(min-width: 1024px)');
  function handle(m){ if(m.matches){ drawer.classList.remove('open'); drawer.hidden = true; toggle.setAttribute('aria-expanded','false'); lockBody(false); } }
  if (mq.addEventListener) { mq.addEventListener('change', handle); } else { mq.addListener(handle); }
  handle(mq);
});
  } catch(e) { console.error(e); }
})();

})();
